<!-- <div class="carousel-box col-xs-12 col-sm-6 col-md-12" *ngIf="modalRequired === 'N'">
  <div id="{{crName}}" class="carousel slide" data-wrap="true" data-interval="false" data-keyboard="true" data-qa="home-carousel">
    <div id="prucarousel_inner" class="carousel-inner item">
      <div *ngFor="let slide of slides;let i=index" class="item" [ngClass]="i==0?'active':''">
        <div [innerHTML]="slide.helpoverlay_description"></div>
      </div>
    </div>
    <div class="carousel-control-row">
      <a id="pru_prev" class="carousel-control left" [href]="crHash" role="button" data-slide="prev">Prev</a>
      <ul id="prucarousel" class="carousel-indicators" data-qa="carousel-indicators">
        <li [attr.data-target]="'#'+crName" tabindex="0" *ngFor="let slide of slides;let i=index" [ngClass]="i==0?'active':''" [attr.data-slide-to]="i">{{i+1}}</li>
      </ul>
      <a id="pru_next" class="carousel-control right" [href]="crHash" role="button" data-slide="next">Next</a>
    </div>
  </div>
</div> -->
<a href="#" data-toggle="modal" data-target="#modal-helpoverlay" id="myIntroVideo">{{displayLink}}</a>
<div id="modal-helpoverlay" role="dialog" class="modal fade overlaymodal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog" aria-label="Help window">
    <div class="modal-content">
      <div class="modal-header p-0">
        <button type="button" class="close" data-dismiss="modal"><span class="sr-only">Close</span></button>
      </div>
      <div class="modal-body">
        <div>
          <div class="carousel-box">
            <div id="{{crName}}" class="carousel slide" data-wrap="true" data-interval="false" data-keyboard="true" data-qa="home-carousel">
              <div id="prucarousel_inner" class="carousel-inner">
                <div *ngFor="let slide of slides;let i=index" class="item" [ngClass]="i==0?'active':''">
                  <div [innerHTML]="slide.helpoverlay_description"></div>
                </div>
              </div>
              <!-- /.carousel-inner -->
              <div class="carousel-control-row">
                <a id="pru_prev" class="carousel-control left" [href]="crHash" role="button" data-slide="prev">Prev</a>
                <ul id="prucarousel" class="carousel-indicators" data-qa="carousel-indicators">
                  <li [attr.data-target]="'#'+crName" tabindex="0" *ngFor="let slide of slides;let i=index" [ngClass]="i==0?'active':''" [attr.data-slide-to]="i">{{i+1}}</li>
                </ul>
                <a id="pru_next" class="carousel-control right" [href]="crHash" role="button" data-slide="next">Next</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
